import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "main-content-container",
    "data-cy": "hospitals-page"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col me-auto" };
const _hoisted_4 = {
    key: 0,
    class: "col",
    cols: "auto"
};
const _hoisted_5 = { class: "col-auto" };
const _hoisted_6 = { class: "row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_acl = _resolveDirective("acl");
    return ($props.access)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives(_createVNode($setup["ViewHospital"], { ref: "viewHospitalModal" }, null, 512), [
                [_directive_acl, $props.access, "all"]
            ]),
            _withDirectives(_createVNode($setup["AddHospital"], {
                ref: "addHospitalModal",
                access: $props.access,
                onCreated: $setup.refetch
            }, null, 8, ["access"]), [
                [_directive_acl, $props.access, "all"]
            ]),
            _withDirectives(_createVNode($setup["EditHospital"], {
                ref: "editHospitalModal",
                access: $props.access,
                onEdited: $setup.refetch
            }, null, 8, ["access"]), [
                [_directive_acl, $props.access, "all"]
            ]),
            ($setup.currentUserStore.isRoot)
                ? (_openBlock(), _createBlock($setup["DeleteHospital"], {
                    key: 0,
                    ref: "deleteHospitalModal",
                    access: $props.access,
                    onDeleted: $setup.refetch
                }, null, 8, ["access"]))
                : _createCommentVNode("", true),
            ($setup.currentUserStore.isRoot)
                ? (_openBlock(), _createBlock($setup["InspectHospitalRequest"], {
                    key: 1,
                    ref: "inspectHospitalRequestModal",
                    access: $props.access,
                    onUpdated: $setup.refetch
                }, null, 8, ["access"]))
                : _createCommentVNode("", true),
            _createVNode($setup["BContainer"], { fluid: "" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_HEADER')), 1)
                        ]),
                        ($setup.allHospitalsLoading || $setup.allHospitalChangeRequestLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode($setup["Loading"])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                            ($setup.currentUserStore.isRoot)
                                ? (_openBlock(), _createBlock($setup["BButton"], {
                                    key: 0,
                                    variant: "secondary",
                                    onClick: _cache[0] || (_cache[0] = ($event) => ($setup.addHospitalModal.show()))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(`+ ${_ctx.$t('JTADM_HOSPITALS_ADD_NEW_HOSPITAL')}`), 1)
                                    ]),
                                    _: 1
                                }))
                                : _withDirectives((_openBlock(), _createBlock($setup["BButton"], {
                                    key: 1,
                                    variant: "secondary",
                                    onClick: _cache[1] || (_cache[1] = ($event) => ($setup.addHospitalModal.show()))
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                            _createTextVNode(_toDisplayString(`+ ${_ctx.$t('JTADM_HOSPITALS_HOSPITAL_REQUEST')}`), 1)
                                        ])), [
                                            [_directive_acl, $props.access, "all"]
                                        ])
                                    ]),
                                    _: 1
                                })), [
                                    [_directive_acl, $props.access, "all"]
                                ])
                        ])
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode($setup["Card"], {
                            icon: "dripicons-medical",
                            "bg-color": "bg-aqua",
                            "bg-color-card": $setup.hospitalsVisible ? 'bg-grey' : 'bg-white',
                            number: $setup.totalHospitals,
                            text: _ctx.$t('JTADM_GRID_TOTAL'),
                            onClick: _cache[2] || (_cache[2] = ($event) => ($setup.hospitalsVisible = true))
                        }, null, 8, ["bg-color-card", "number", "text"]),
                        ($setup.currentUserStore.isRoot)
                            ? (_openBlock(), _createBlock($setup["Card"], {
                                key: 0,
                                "bg-color": "bg-yellow",
                                icon: "dripicons-document-edit",
                                "bg-color-card": $setup.hospitalsVisible ? 'bg-white' : 'bg-grey',
                                number: $setup.totalHospitalChangeRequests,
                                text: _ctx.$t('JTADM_HOSPITALS_HOSPITAL_REQUESTS'),
                                onClick: _cache[3] || (_cache[3] = ($event) => ($setup.hospitalsVisible = false))
                            }, null, 8, ["bg-color-card", "number", "text"]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                    _createVNode($setup["CommonSearchInput"], {
                        "model-value": $setup.searchQuery,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.searchQuery) = $event)),
                        "data-cy": "hospital-search",
                        placeholder: _ctx.$t('JTADM_SEARCH_CENTERS'),
                        onRefetch: $setup.refetch
                    }, null, 8, ["model-value", "placeholder"]),
                    ($setup.hospitalsVisible)
                        ? (_openBlock(), _createBlock($setup["HospitalList"], {
                            key: 0,
                            ref: "hospitalList",
                            access: $props.access,
                            "search-term": $setup.searchQuery,
                            onEdit: $setup.editHospitalModal?.show,
                            onDelete: $setup.deleteHospitalModal?.show,
                            onLoading: _cache[5] || (_cache[5] = (loading) => ($setup.allHospitalsLoading = loading)),
                            onUpdateCounters: $setup.updateCounters,
                            onView: $setup.viewHospitalModal?.show
                        }, null, 8, ["access", "search-term", "onEdit", "onDelete", "onView"]))
                        : (_openBlock(), _createBlock($setup["HospitalChangeRequestList"], {
                            key: 1,
                            ref: "hospitalChangeRequestList",
                            access: $props.access,
                            "search-term": $setup.searchQuery,
                            onLoading: _cache[6] || (_cache[6] = (loading) => ($setup.allHospitalChangeRequestLoading = loading)),
                            onUpdateCounters: $setup.updateCounters,
                            onView: $setup.inspectHospitalRequestModal?.show
                        }, null, 8, ["access", "search-term", "onView"]))
                ]),
                _: 1
            })
        ]))
        : _createCommentVNode("", true);
}
